import Sider from './Sider';
import Header from './Header';
import Auth from './AuthContainer';
import SignInFm from './SignInForm';
import SignUpFm from './SignUpForm';
import UserDropdown from './HeaderUserDropdown';
import Crop from './ImgCrop';
import GForm from './GroupForm';

import AddPeopleToGroupMdl from './AddPeopleToGroupModal';

export const AppSider = Sider;
export const AppHeader = Header;
export const AuthContainer = Auth;
export const SignInForm = SignInFm;
export const SignUpForm = SignUpFm;
export const HeaderUserDropdown = UserDropdown;
export const ImgCrop = Crop;
export const GroupForm = GForm;
export const AddPeopleToGroupModal = AddPeopleToGroupMdl;
